import {Inject, Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbsService {

  private _isEnabled: BehaviorSubject<boolean> = new BehaviorSubject(true);
  public readonly isEnabled: Observable<boolean> = this._isEnabled.asObservable();

  constructor() {
  }

  public getIsEnabled(): Observable<boolean> {
    return this.isEnabled;
  }

  public on() {
    this._isEnabled.next(true);
  }

  public off() {
    this._isEnabled.next(false);
  }

}
